import React, { useState } from "react"
import Logo from "../../assets/white-logo.svg"
import Arrow from "../../assets/white-arrow.svg"
import * as S from "./footer.styles"
import { Collapse, Container, Grid, Stack } from "@mui/material"

const Footer = () => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false)

  return (
    <S.Wrapper>
      <Container maxWidth="xl">
        <Grid container spacing={{ xs: 3, md: 6 }}>
          <Grid item xs={12} md={6}>
            <S.LogoWrapper url={"/"}>
              <Logo />
            </S.LogoWrapper>
            <S.Content>
              Title One USA is a real estate escrow and closing company based in
              Canton, Ohio. Founded in 1985, we proudly serve real estate
              agents, investors, lenders, and builders in 14 states.
            </S.Content>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <S.GroupTitle>Company</S.GroupTitle>
            <Stack spacing={1}>
              <S.StyledText
                className={`center ${isOpenDropdown ? "open" : ""}`}
                onClick={() => setIsOpenDropdown(!isOpenDropdown)}
              >
                Title services
                <Arrow />
              </S.StyledText>
              <Collapse in={isOpenDropdown} timeout="auto" unmountOnExit>
                <Stack spacing={{ xs: 1, sm: 1.5 }}>
                  <S.StyledLink url="/for-local-investors">
                    For Local Investors
                  </S.StyledLink>
                  <S.StyledLink url="/for-large-scale-investors">
                    For Large-Scale Investors
                  </S.StyledLink>
                  <S.StyledLink url="/for-real-estate-agents">
                    For Real Estate Agents
                  </S.StyledLink>
                </Stack>
              </Collapse>
              <S.StyledLink url="/about-us">About us</S.StyledLink>
              <S.StyledLink url="/blog">Blog</S.StyledLink>
              <S.StyledLink url="/contact">Contact us</S.StyledLink>
            </Stack>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <S.GroupTitle>Locations</S.GroupTitle>
            <Stack spacing={{ xs: 1, sm: 1.5 }}>
              <S.StyledText>Headquartered in Canton, OH</S.StyledText>
              <S.StyledText>
                Licensed in OH, AL, PA, IN, MO, MN, KS, KY, CO, IN, MI, TN
              </S.StyledText>
            </Stack>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <S.GroupTitle>Contacts</S.GroupTitle>
            <Stack spacing={1}>
              <S.StyledLink url="tel:330-491-4963">
                Phone: 330-491-4963
              </S.StyledLink>
              <S.StyledLink url="tel:330-493-5312">
                Fax: 330-493-5312
              </S.StyledLink>
            </Stack>
          </Grid>
        </Grid>
        <S.BottomWrapper>
          <S.StyledLink className="bottom" url="/privacy-policy">
            Privacy Policy
          </S.StyledLink>
          <S.StyledLink className="bottom" url="/terms-and-conditions">
            Terms and Conditions
          </S.StyledLink>
          <S.StyledText className="bottom">
            © Title One {new Date().getFullYear()}. All rights reserved
          </S.StyledText>
        </S.BottomWrapper>
      </Container>
    </S.Wrapper>
  )
}

export default Footer
